import { mapEnumToOptionsArray } from 'utils';

import { ClaimFeedback } from 'codegen';
import {
  InitialTableActions,
  TColumn,
  TEditableColumn,
  TFieldProps,
} from 'types';

export const columns: TEditableColumn<ClaimFeedback>[] = [{
  width: 250,
  title: 'Claim Resolution For Operator',
  dataIndex: 'resolutionReason',
  field: {
    type: TFieldProps.type.Textarea,
    placeholder: 'Fill claim resolution',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  width: 150,
  type: TColumn.type.Status,
  title: 'Claim Status',
  dataIndex: 'resolutionStatus',
  field: {
    type: TFieldProps.type.Select,
    placeholder: 'Select status',
    options: mapEnumToOptionsArray(ClaimFeedback.resolutionStatus),
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  width: 250,
  title: 'Header In English',
  dataIndex: 'englishHeader',
  field: {
    type: TFieldProps.type.Textarea,
    placeholder: 'Fill english header',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  width: 250,
  title: 'Text For Collectors In English',
  dataIndex: 'englishMessage',
  field: {
    type: TFieldProps.type.Textarea,
    placeholder: 'Fill english message',
    rules: [{
      message: 'Required',
      required: true,
    }, {
      max: 255,
      message: 'Max length 255',
    }],
  },
}, {
  width: 250,
  title: 'Header In French',
  dataIndex: 'frenchHeader',
  field: {
    type: TFieldProps.type.Textarea,
    placeholder: 'Fill french header',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}, {
  width: 250,
  title: 'Text For Collectors In French',
  dataIndex: 'frenchMessage',
  field: {
    type: TFieldProps.type.Textarea,
    placeholder: 'Fill french message',
    rules: [{
      message: 'Required',
      required: true,
    }, {
      max: 255,
      message: 'Max length 255',
    }],
  },
}];

export const initTableActions = [{
  type: InitialTableActions.Edit,
}, {
  type: InitialTableActions.Toggle,
}];
